import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'html:pre': () => import('./components/code')
    }
});
